import { createCookie, getCookie } from '@/core/utils/cookieUtils';
import type {
  GetDataOptions,
  SaveDataOptions,
} from '../../domain/interfaces/StorageRepository';

import { deserialize, serialize } from './storageSerialization';

export class CookieStorageRepository {
  saveData<T>(key: string, value: T, options: SaveDataOptions): void {
    const serialized = serialize(value);
    createCookie(key, serialized, options.expiryDays ?? 0);
  }

  getData<T>(key: string, _options?: GetDataOptions): T | null {
    const raw = getCookie(key);
    if (raw == null) return null;
    return deserialize<T>(raw);
  }
}

